import LandingPage from "@/components/LandingPage";

const internal = [
  { label: "Videoproduktion Bochum", to: "/videoproduktion-bochum" },
  { label: "Videoproduktion Ruhrgebiet", to: "/videoproduktion-ruhrgebiet" },
  { label: "Imagefilm Bochum", to: "/imagefilm-bochum" },
  { label: "Motorsport-Videoproduktion", to: "/motorsport-videoproduktion" },
  { label: "Alle Leistungen", to: "/leistungen" },
];

const VideoproduktionNRW = () => (
  <LandingPage
    path="/videoproduktion-nrw"
    metaTitle="Videoproduktion NRW | Cinematic Filmagentur 4Facemedia"
    metaDescription="Videoproduktion in NRW: Imagefilm, Eventfilm, Motorsport- & Sport-Content. Aus Bochum für ganz Nordrhein-Westfalen – cinematic, planbar & lokal verankert."
    eyebrow="Videoproduktion · NRW · Ruhrgebiet"
    h1={
      <>
        Videoproduktion <span className="text-gradient">in ganz NRW</span>.
      </>
    }
    intro="Aus Bochum für ganz Nordrhein-Westfalen: Imagefilme, Eventfilme, Motorsport- & Sport-Content. Cinematic produziert, strategisch gedacht – von Köln bis Münster, vom Rheinland bis ins Sauerland."
    serviceName="Videoproduktion NRW"
    serviceDescription="Cinematic Videoproduktion in ganz Nordrhein-Westfalen – mit Sitz in Bochum. Imagefilme, Eventfilme, Motorsport- und Sport-Content für Unternehmen, Vereine und Veranstalter."
    areaServed={[
      "Nordrhein-Westfalen",
      "Ruhrgebiet",
      "Bochum",
      "Dortmund",
      "Essen",
      "Düsseldorf",
      "Köln",
      "Münster",
      "Aachen",
      "Bonn",
    ]}
    bullets={[
      { title: "Aus dem Herzen von NRW", text: "Standort Bochum, im Einsatz in ganz Nordrhein-Westfalen – kurze Wege, schnelle Drehs, persönliche Betreuung." },
      { title: "Imagefilm & Markenfilm", text: "Cinematic Imagefilme für Unternehmen aus dem Rheinland, Ruhrgebiet, Münsterland & Sauerland." },
      { title: "Eventfilm & Aftermovie", text: "Eventbegleitung für Firmenevents, Galas, Festivals und Großveranstaltungen in NRW." },
      { title: "Motorsport & Sport", text: "Spezialisierung auf Motorsport (Nürburgring, Zolder, Spa) und Sport-Content – mit Strecken-Know-how." },
      { title: "Foto & Video aus einer Hand", text: "Konsistente Bildsprache, ein Ansprechpartner – Fotograph und Bewegtbild parallel produziert." },
      { title: "Planbar & transparent", text: "Festpreis-Angebote, klare Deadlines, dokumentierter Workflow vom Briefing bis Delivery." },
    ]}
    faqs={[
      { q: "Dreht ihr in ganz NRW?", a: "Ja. Unser Sitz ist Bochum, von hier aus erreichen wir alle Regionen in NRW – Rheinland, Ruhrgebiet, Münsterland, Ostwestfalen und Sauerland – meist in unter 90 Minuten." },
      { q: "Wie schnell könnt ihr in NRW vor Ort sein?", a: "Bei kurzfristigen Anfragen meist innerhalb weniger Tage, in Notfällen auch innerhalb von 24 Stunden – sofern Crew und Equipment verfügbar sind." },
      { q: "Welche Branchen betreut ihr in NRW?", a: "Schwerpunkt: Motorsport, Sport, Eventbegleitung & Content. Daneben Imagefilm, Branding, Webdesign und Social Media für Unternehmen aus ganz Nordrhein-Westfalen." },
      { q: "Was kostet eine Videoproduktion in NRW?", a: "Das hängt vom Format ab: Eventfilm ab ca. 2.500 €, Imagefilm ab ca. 4.500 €. Reisetage innerhalb NRW sind in den meisten Angeboten enthalten." },
    ]}
    internalLinks={internal}
  />
);

export default VideoproduktionNRW;
